import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import messages from "../../_i18n/fr.json";
import { gris2 } from "../../theme";
import Bouton from "../Button/Bouton";
import UncontrolledInputField from "../input/UncontrolledInputField";
import UncontrolledSelect from "../select/UncontrolledSelect";
import styles from "./styles";

const DropdownStatuts = [
  {
    key: "VALIDE",
    text: messages.statutDossierLocation["VALIDE"],
    value: "VALIDE",
  },
  {
    key: "NON_VALIDE",
    text: messages.statutDossierLocation["NON_VALIDE"],
    value: "NON_VALIDE",
  },
  {
    key: "VALIDE_AGREE",
    text: messages.statutDossierLocation["VALIDE_AGREE"],
    value: "VALIDE_AGREE",
  },
  {
    key: "VALIDE_AGREE_DIFFERE",
    text: messages.statutDossierLocation["VALIDE_AGREE_DIFFERE"],
    value: "VALIDE_AGREE_DIFFERE",
  },
  {
    key: "VALIDE_NON_AGREE",
    text: messages.statutDossierLocation["VALIDE_NON_AGREE"],
    value: "VALIDE_NON_AGREE",
  },
];

const DialogStatut: React.FC<{
  handleForcerStatutDossier: (params: any) => void;
}> = ({ handleForcerStatutDossier }) => {
  const [open, setOpen] = useState(false);
  const [statut, setStatut] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorStatut, setErrorStatut] = useState("");

  const onOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setErrorMessage("");
    setErrorStatut("");
  };

  const onForcerStatutDossier = () => {
    if (!message) {
      setErrorMessage("Le commentaire est obligatoire");
    }
    if (!statut) {
      setErrorStatut("Le statut est obligatoire");
    }
    if (statut && message) {
      const params = {
        statut,
        message,
      };
      handleForcerStatutDossier(params);
      onClose();
    }
  };

  return (
    <Box>
      <Link
        component="button"
        sx={{
          color: gris2,
          marginLeft: "16px",
        }}
        underline="always"
        onClick={onOpen}
      >
        Modifier le statut du dossier
      </Link>
      <Dialog
        sx={styles}
        open={open}
        onClose={onClose}
        className="modifyStatuts"
        aria-labelledby="dialog-statut-change"
        aria-describedby="Changement de statut location"
        maxWidth="xs"
      >
        <DialogTitle id="dialog-title">
          Modifier le statut du dossier
        </DialogTitle>
        <DialogContent>
          <UncontrolledSelect
            required
            label="Statut"
            options={DropdownStatuts}
            handleChange={(id: any, value: string) => setStatut(value)}
          />
          <UncontrolledInputField
            multiline
            required
            rows={3}
            label="Commentaire"
            placeholder="Ajouter un commentaire"
            maxLength={255}
            handleChange={(id: any, value: string) =>
              setMessage(value.toString())
            }
          />
          {errorStatut && <Typography color="error">{errorStatut}</Typography>}
          {errorMessage && (
            <Typography color="error">{errorMessage}</Typography>
          )}
        </DialogContent>
        <DialogActions className="actionButton">
          <Bouton
            label="Annuler"
            variant="contained"
            color="secondary"
            size="small"
            onClick={onClose}
          />
          <Bouton
            label="Valider"
            variant="contained"
            color="primary"
            size="small"
            onClick={onForcerStatutDossier}
          />
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DialogStatut;
